import axios from '@/libs/api.request'
import Qs from 'qs'
import * as auth from '@/api/auth'
import * as ResponseStatus from '@/api/response-status'

/**
 * post请求，application/json
 * @param {*} url 请求url
 * @param {*} data json对象
 * @param {*} headers 如headers: {
                          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                          'Authorization': 'Bearer ' + getLocalStorageToken()
                        }
                      如果不需要传递headers，则直接使用{}
 */
export const doPostJson = (url, data, headers) => {
  //headers['Authorization'] = 'Bearer ' + getLocalStorageToken()
  headers[auth.HEADER_APPID] = auth.APPID
  if (auth.APP_AUTH_ENABLE) {
    headers[auth.HEADER_REQURL] = url
    let timestamp = new Date().getTime()
    let nonceStr = uuid()
    headers[auth.HEADER_TIMESTAMP] = timestamp
    headers[auth.HEADER_NONCESTR] = nonceStr
    headers[auth.HEADER_SIGN] = auth.generateSignJson(url, timestamp, nonceStr, data)
  }
  return axios.request({
    url: url,
    method: 'POST',
    data: data,
    headers: headers
  })
}

/**
 * post请求，application/x-www-form-urlencoded
 * @param {*} url 请求url
 * @param {*} data json对象
 * @param {*} headers 如headers: {
                          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                          'Authorization': 'Bearer ' + getLocalStorageToken()
                        }
                      如果不需要传递headers，则直接使用{}
 */
export const doPostQs = (url, data, headers) => {
  headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  //headers['Authorization'] = 'Bearer ' + getLocalStorageToken()
  headers[auth.HEADER_APPID] = auth.APPID
  if (auth.APP_AUTH_ENABLE) {
    headers[auth.HEADER_REQURL] = url
    let timestamp = new Date().getTime()
    let nonceStr = uuid()
    headers[auth.HEADER_TIMESTAMP] = timestamp
    headers[auth.HEADER_NONCESTR] = nonceStr
    headers[auth.HEADER_SIGN] = auth.generateSignQs(url, timestamp, nonceStr, data)
  }
  return axios.request({
    url: url,
    method: 'POST',
    data: Qs.stringify(data, {arrayFormat: 'repeat'}),
    headers: headers
  })
}

/**
 * post请求，application/x-www-form-urlencoded，返回arraybuffer数据，如图片
 * @param {*} url 请求url
 * @param {*} data json对象
 * @param {*} headers 如headers: {
                          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                          'Authorization': 'Bearer ' + getLocalStorageToken()
                        }
                      如果不需要传递headers，则直接使用{}
 */
export const doPostQsArrayBuffer = (url, data, headers) => {
  headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  //headers['Authorization'] = 'Bearer ' + getLocalStorageToken()
  headers[auth.HEADER_APPID] = auth.APPID
  if (auth.APP_AUTH_ENABLE) {
    headers[auth.HEADER_REQURL] = url
    let timestamp = new Date().getTime()
    let nonceStr = uuid()
    headers[auth.HEADER_TIMESTAMP] = timestamp
    headers[auth.HEADER_NONCESTR] = nonceStr
    headers[auth.HEADER_SIGN] = auth.generateSignQs(url, timestamp, nonceStr, data)
  }
  return axios.request({
    url: url,
    method: 'POST',
    data: Qs.stringify(data, {arrayFormat: 'repeat'}),
    headers: headers,
    responseType: "arraybuffer"
  })
}

/**
*  post请求，application/x-www-form-urlencoded，返回arraybuffer数据，如图片
* @param self this
*/
export const doPostQsBlob = (url, data, headers) => {
  headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  //headers['Authorization'] = 'Bearer ' + getLocalStorageToken()
  headers[auth.HEADER_APPID] = auth.APPID
  if (auth.APP_AUTH_ENABLE) {
    headers[auth.HEADER_REQURL] = url
    let timestamp = new Date().getTime()
    let nonceStr = uuid()
    headers[auth.HEADER_TIMESTAMP] = timestamp
    headers[auth.HEADER_NONCESTR] = nonceStr
    headers[auth.HEADER_SIGN] = auth.generateSignQs(url, timestamp, nonceStr, data)
  }
  return axios.request({
    url: url,
    method: 'POST',
    data: Qs.stringify(data, {arrayFormat: 'repeat'}),
    headers: headers,
    responseType: "blob"
  })
}

/**
 * get请求
 * @param {*} url 请求url，包含请求参数
 * @param {*} headers 如headers: {
                          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                          'Authorization': 'Bearer ' + getLocalStorageToken()
                        }
                      如果不需要传递headers，则直接使用{}
 */
export const doGet = (url, headers) => {
  headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  //headers['Authorization'] = 'Bearer ' + getLocalStorageToken()
  headers[auth.HEADER_APPID] = auth.APPID
  if (auth.APP_AUTH_ENABLE) {
    headers[auth.HEADER_REQURL] = url.indexOf('?') > 0 ? url.split('?')[0] : url
    let timestamp = new Date().getTime()
    let nonceStr = uuid()
    headers[auth.HEADER_TIMESTAMP] = timestamp
    headers[auth.HEADER_NONCESTR] = nonceStr
    headers[auth.HEADER_SIGN] = auth.generateSignGet(url, timestamp, nonceStr)
  }
  return axios.request({
    url: url,
    method: 'GET',
    headers: headers
  })
}

/**
 * 取指定多少天前或多少天后的时间
 * getDate(7)：7天后的时间
 * getDate(-7)：7天前的时间
 */
export const getDate = (date1, days) => {
  var time1 =
    date1.getFullYear() +
    '-' +
    (date1.getMonth() + 1) +
    '-' +
    date1.getDate()
  var date2 = new Date(date1)
  date2.setDate(date1.getDate() + days)
  var time2 =
    date2.getFullYear() +
    '-' +
    ((date2.getMonth() + 1) < 10 ? '0' + (date2.getMonth() + 1) : (date2.getMonth() + 1)) +
    '-' +
    (date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate())
  return time2
}

/**
 * 解析text文本到JSON对象
 * @param {*} data 
 */
export const parseJson = (data) => {
  return new Promise((resolve, reject) => {
    let json = JSON.parse(data)
    resolve(json)
  })
}

/**
 * 读取arrayBuffer数据到FileReader对象中，FileReader中存储字符串
 * @param {*} arrayBufferData 
 */
export const arrayBufferToReader = (arrayBufferData) => {
  let blob = new Blob([arrayBufferData])
  let reader = new FileReader()
  reader.readAsText(blob, 'utf-8')
  return reader
}

/**
 * 把arrayBuffer数据转化成指定类型的图片
 * @param {*} imageType 
 * @param {*} arrayBufferData 
 */
export const arrayBufferToImage = (imageType, arrayBufferData) => {
  return 'data:image/' + imageType + ';base64,' + btoa(
    new Uint8Array(arrayBufferData).reduce((data, byte) => data + String.fromCharCode(byte), '')
  )
}

/**
 * 根据指定的多个数据字典的code获取多个数据字典项的值，并缓存到前端
 * @param {*} dictCodes 如 ['IS_ACTIVE', 'PAYMENT_TYPE']
 */
export const getDataDict = (dictCodes) => {
  let dataDictItems = {}
  let dictCodesWithNoItems = []
  return new Promise((resolve, reject) => {
    if (!dictCodes || dictCodes.length === 0) {
      resolve(dataDictItems)
      return
    }
    dictCodes.forEach(dictCode => {
      let dictItems = localStorage.getItem(dictCode)
      if (dictItems) {
        dataDictItems[dictCode] = JSON.parse(dictItems)
      } else {
        dictCodesWithNoItems.push(dictCode)
      }
    })
    if (dictCodesWithNoItems.length <= 0) {
      resolve(dataDictItems)
    } else {
      doPostJson('/data-dict-and-item/any/by-dict-codes', dictCodesWithNoItems, {}).then(response => {
        if (response.data.code === ResponseStatus.OK) {
          dictCodesWithNoItems.forEach(dictCode => {
            localStorage.setItem(dictCode, JSON.stringify(response.data.data[dictCode]))
            dataDictItems[dictCode] = response.data.data[dictCode]
          })
        }
        resolve(dataDictItems)
      }).catch(error => {
        reject(error)
      })
    }
  })
}

/**
 * 获取表格中数据字典项
 * @param {*} self 
 * @param {*} dictCode 从指定的数据字典中获取
 * @param {*} value 
 */
export const getDataDictItemDisplayValue = (self, dictCode, value) => {
  let dictItems = self.dataDictItems[dictCode]
  if (!dictItems) {
    return {
      displayValue: value
    }
  }
  if (value !== null && value !== undefined && value !== '') {
    for (let i = 0, len = dictItems.length; i < len; i++) {
      if (value === dictItems[i].value) {
        return dictItems[i]
      }
    }
  }
  return {
    displayValue: value
  }
}

/**
 * 从指定的数据字典中获取下拉菜单显示的数据，把默认值
 * @param {*} self 
 * @param {*} dictCode 指定的数据字典
 * @param {*} formProp select下拉框中的form对应的属性名
 * @param {*} dataProp 整个select下拉框的数据对应的data属性名
 */
export const getSelectDictItems = (self, dictCode, formProp, dataProp) => {
  let dictItems = self.dataDictItems[dictCode]
  if (dictItems && dictItems.length > 0) {
    self[dataProp] = dictItems
    let itemValue = dictItems[0].value
    if (itemValue === null || itemValue === undefined || itemValue === '') {
      // 如果数据项值是空的，则需要把显示的中文值赋值给value
      self[dataProp].forEach(item => {
        item.value = item.displayValue
      })
    }
    if (self.form) {
      // 只有添加和编辑下拉菜单需要有下拉默认值
      for (let i = 0, len = dictItems.length; i < len; i++) {
        let item = dictItems[i]
        if (item.isDefault === 1) {
          self.form[formProp] = item.value
          break
        }
      }
    }
  }
}

/**
 * 获取详情中数据字典项的显示值
 * @param {*} self 
 * @param {*} dictCode 
 * @param {*} formProp 
 */
export const getDetailDictItemDisplayValue = (self, dictCode, formProp) => {
  let dictItems = self.dataDictItems[dictCode]
  for (let i = 0, len = dictItems.length; i < len; i++) {
      if (self.form[formProp] === dictItems[i].value) {
        self.form[formProp] = dictItems[i].displayValue
        break
      }
  }
}

/**
 * 判断数据字典下拉菜单中是否有指定的值，如果没有则追加值
 * @param {*} selectList 
 * @param {*} value 
 */
export const pushSelectDictItems = (selectList, value, displayValue) => {
  let flag = true
  for (var i = 0; i < selectList.length; i++) {
      let item = selectList[i]
      if (item.value == value) {
          flag = false
          break
      }
  }
  if (flag) {
      selectList.push({
          value: value,
          displayValue: displayValue
      })
  }
  return selectList
}

export const uuid = () => {
  let s = []
  let hexDigits = "0123456789abcdef"
  for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-"
  let uuid = s.join("")
  return uuid
}

/**
 * 格式化日期
 * @param {} fmt 
 * @param {*} date 
 */
export const dateFormat = (fmt, date) => {
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}

/**
 * 计算两个日期之间的差异
 * @param {*} startDate 起始日期 2020-03-19格式
 * @param {*} endDate 结束日期 2020-03-19格式
 */
export const dateDiff = (startDate, endDate) => {
  var  aDate,  oDate1,  oDate2,  iDays 
  aDate  =  startDate.split("-") 
  oDate1  =  new  Date(aDate[1]  +  '-'  +  aDate[2]  +  '-'  +  aDate[0])    //转换为12-18-2006格式 
  aDate  =  endDate.split("-") 
  oDate2  =  new  Date(aDate[1]  +  '-'  +  aDate[2]  +  '-'  +  aDate[0]) 
  iDays  =  parseInt(Math.abs(oDate1  -  oDate2)  /  1000  /  60  /  60  /24)    //把相差的毫秒数转换为天数 
  return  iDays 
}

/** 修改时格式化日期 */
export const editDateFormat = (date) => {
  var d = new Date(date); 
  var month = d.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var day = d.getDate()
  day = day < 10 ? '0' + day : day
  d=d.getFullYear() + '-' + month + '-' + day;
  return d
}
    
/**
 * 数字格式化并保留2为小数
 * @param {*} value 
 */
export const numFormat = (value) => {
  var param = {};
  var k = 10000,
      sizes = ['', '万', '亿', '万亿'],
      i;
  if(value < k){
      param.value =value
      param.unit=''
  }else{
      i = Math.floor(Math.log(value) / Math.log(k)); 
      param.value = ((value / Math.pow(k, i))).toFixed(2);
      param.unit = sizes[i];
  }
  return param;
}


// WEBPACK FOOTER //
// ./src/api/utils-v2.js